import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import { subscription_details } from "../../../core/data/json/subscriptiondetails";
import PredefinedDateRanges from "../../../core/common/datePicker";
import Table from "../../../core/common/dataTable/index";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import {
  company_short_name,
  company_address_env,
  company_email_env,
} from "../../../environment";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { showBasicAlert } from "../../../core/common/useAlert";

const Subscription = () => {
  const columns = [
    {
      title: "Company Name",
      dataIndex: "CompanyName",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <Link to="#" className="avatar avatar-md border rounded-circle">
            <ImageWithBasePath
              src={`${record.Image || "assets/img/users/user-01.jpg"}`}
              className="img-fluid"
              alt="img"
            />
          </Link>
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#">{record.CompanyName}</Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => {
        const lengthA = a.CompanyName ? a.CompanyName.toString().length : 0;
        const lengthB = b.CompanyName ? b.CompanyName.toString().length : 0;
        return lengthA - lengthB;
      },
    },
    {
      title: "Plan",
      dataIndex: "Plan",
      sorter: (a: any, b: any) => {
        const lengthA = a.Plan ? a.Plan.toString().length : 0;
        const lengthB = b.Plan ? b.Plan.toString().length : 0;
        return lengthA - lengthB;
      },
    },
    {
      title: "Billing Cycle",
      dataIndex: "BillCycle",
      render: (text: String, record: any) => <span>{record.BillCycle}</span>,
      sorter: (a: any, b: any) => {
        const lengthA = a.BillCycle ? a.BillCycle.toString().length : 0;
        const lengthB = b.BillCycle ? b.BillCycle.toString().length : 0;
        return lengthA - lengthB;
      },
    },
    {
      title: "Payment Method",
      dataIndex: "PaymentMethod",
      sorter: (a: any, b: any) => {
        const lengthA = a.PaymentMethod ? a.PaymentMethod.toString().length : 0;
        const lengthB = b.PaymentMethod ? b.PaymentMethod.toString().length : 0;
        return lengthA - lengthB;
      },
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      sorter: (a: any, b: any) => parseFloat(a.Amount) - parseFloat(b.Amount),
    },
    {
      title: "Created Date",
      dataIndex: "CreatedDate",
      sorter: (a: any, b: any) =>
        new Date(a.CreatedDate).getTime() - new Date(b.CreatedDate).getTime(),
    },
    {
      title: "Expired On",
      dataIndex: "ExpiringDate",
      sorter: (a: any, b: any) =>
        new Date(a.ExpiringDate).getTime() - new Date(b.ExpiringDate).getTime(),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${
            text === "Active" ? "badge-success" : "badge-danger"
          } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text: String, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#view_invoice"
            onClick={() => handlePurchaseDetail(record)} // Set the selected company data
          >
            <i className="ti ti-file-invoice" />
          </Link>
          {/* <Link to="#" data-bs-toggle="modal" data-bs-target="#delete_modal">
            <i className="ti ti-trash" />
          </Link> */}
        </div>
      ),
    },
  ];

  const downloadPDF = async () => {
    const element = document.getElementById("view_invoice");

    if (!element) {
      console.error("Element not found!");
      return;
    }

    try {
      // Capture the div
      const canvas = await html2canvas(element, {
        scale: 2, // Improves image quality
        useCORS: true, // Fixes cross-origin images issue
        logging: false, // Reduces console clutter
      });

      // Convert canvas to image
      const imgData = canvas.toDataURL("image/png");

      // Create a new PDF document
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

      pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
      pdf.save("invoice.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Example columns
    const columns = [
      "Company Name",
      "Plan",
      "Billing Cycle",
      "Payment Method",
      "Amount",
      "Created Date",
      "Expired Date",
      "Status",
    ];
    const tableData: (string | number)[][] = filteredData.map((item) => [
      item.CompanyName[0], // Assuming the second element is a string (Company name)
      item.Plan[0], // Plan (string)
      item.BillCycle[0], // Plan (string)
      item.PaymentMethod, // Date (string)
      item.Amount, // Date (string)
      item.CreatedDate, // Date (string)
      item.ExpiringDate, // Date (string)
      item.Status, // Status (string)
    ]);
    // Generate the table in the PDF (no need to pass `doc` as the first argument anymore)
    doc.autoTable({
      head: [columns],
      body: tableData,
    });

    // Save the PDF
    doc.save("subscription.pdf");
  };
  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData); // Convert JSON to sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "invoice.xlsx");
  };

  const [selectedPurchase, setSelectedPurchase] = useState<any | null>(null);

  const handlePurchaseDetail = (record: any) => {
    try {
      var country_id = record.Country;
      var state_id = record.State;
      var city_id = record.City;

      const countryDetail = countries.filter(
        (item) => parseInt(item.id) === parseInt(country_id)
      );
      var countryName = countryDetail[0].name;
      var countryCurrency = countryDetail[0].currency_symbol;
      const stateDetail = statesOrignal.filter(
        (state) => parseInt(state.id) == parseInt(state_id)
      );
      var stateName = stateDetail[0].name;

      // const CityDetail = citiesOrignal.filter(
      //   (city) => parseInt(city.id) == parseInt(city_id)
      // );
      // var cityName = CityDetail[0].name;

      var Address =
        record.BillingAddres1 +
        "," +
        record.BillingAddres2 +
        "," +
        stateName +
        "," +
        countryName +
        "," +
        record.Pincode;
      record.Address = Address;
      record.countryCurrency = countryCurrency;
      setSelectedPurchase(record);
    } catch (e) {
      console.log(e);
    }
  };

  const [responseDataSubscription, setResponseDataSubscription] = useState<
    any | undefined
  >(undefined);

  const [countries, setCountries] = useState<any[]>([]);

  const [statesOrignal, setStatesOrignal] = useState<any[]>([]);

  useEffect(() => {
    // This will run when the component mounts
    const fetchSubscriptionData = async () => {
      try {
        const signature = localStorage.getItem("signature");

        const [response, planResponse, countryResponse, stateResponse] =
          await Promise.all([
            api.post("userService/getSubsriptionData", {
              signature,
            }),
            api.post("userService/getPlan", { signature }),
            api.post("userService/getCountry", { signature }),
            api.post("userService/getState", { signature }),
          ]);

        setResponseDataSubscription(response.data.data);
        setData(response.data.data.purchase_history);
        setFilteredData(response.data.data.purchase_history);
        setPlan(planResponse.data.data);

        setCountries(countryResponse.data.data);

        setStatesOrignal(stateResponse.data.data);

        const data1 = response.data.data.earnings_month_wise.map(
          (item: { total_earning: any }) => parseInt(item.total_earning)
        );
        settotalTransaction((prevState: any) => ({
          ...prevState,
          series: [
            {
              name: "",
              data: data1,
            },
          ],
        }));

        const data2 = response.data.data.total_subscribers_month_wise.map(
          (item: { count: any }) => parseInt(item.count)
        );
        settotalSubscription((prevState: any) => ({
          ...prevState,
          series: [
            {
              name: "",
              data: data2,
            },
          ],
        }));
      } catch (err) {}
    };

    fetchSubscriptionData();
  }, []);

  const [totalTransaction, settotalTransaction] = useState<any>({
    series: [
      {
        name: "",
        data: [6, 2, 8, 4, 3, 8, 1, 3, 6, 5, 9, 2, 8, 1, 4, 8, 9, 8, 2, 1],
      },
    ],
    fill: {
      type: "solid",
      opacity: 1,
    },
    chart: {
      foreColor: "#fff",
      type: "area",
      width: 80,
      toolbar: {
        show: !1,
      },
      zoom: {
        enabled: !1,
      },
      dropShadow: {
        enabled: 0,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#F7A37A"],
      strokeColors: "#fff",
      strokeWidth: 0,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: !1,
    },
    // stroke: {
    //   show: !0,
    //   width: 2.5,
    //   curve: "smooth"
    // },
    stroke: {
      width: 0,
      curve: "monotoneCubic",
    },
    colors: ["#F7A37A"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
    tooltip: {
      theme: "dark",
      fixed: {
        enabled: !1,
      },
      x: {
        show: !1,
      },

      marker: {
        show: !1,
      },
    },
  });

  const [totalSubscription, settotalSubscription] = useState<any>({
    series: [
      {
        name: "",
        data: [6, 2, 8, 4, 3, 8, 1, 3, 6, 5, 9, 2, 8, 1, 4, 8, 9, 8, 2, 1],
      },
    ],
    fill: {
      type: "solid",
      opacity: 1,
    },
    chart: {
      foreColor: "#fff",
      type: "area",
      width: 80,
      toolbar: {
        show: !1,
      },
      zoom: {
        enabled: !1,
      },
      dropShadow: {
        enabled: 0,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#70B1FF"],
      strokeColors: "#fff",
      strokeWidth: 0,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: !1,
    },
    // stroke: {
    //   show: !0,
    //   width: 2.5,
    //   curve: "smooth"
    // },
    stroke: {
      width: 0,
      curve: "monotoneCubic",
    },
    colors: ["#70B1FF"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
    tooltip: {
      theme: "dark",
      fixed: {
        enabled: !1,
      },
      x: {
        show: !1,
      },

      marker: {
        show: !1,
      },
    },
  });

  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState(data);

  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [planFilter, setPlanFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("Last 7 Days");
  const [selectedStartDate, setSelectedStartDate] =
    useState<moment.Moment | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | null>(
    null
  );
  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };
  const handleReset = () => {
    setFilteredData(data);
  };

  const [plan, setPlan] = useState<any[]>([]);

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          if (
            statusFilter &&
            item.Status.toLowerCase() !== statusFilter.toLowerCase()
          ) {
            return false;
          }
          if (planFilter && item.Plan !== planFilter) {
            return false;
          }
          // Apply date range filter (if dates are selected)
          if (selectedStartDate && selectedEndDate) {
            const createdDate = new Date(item.CreatedDate);

            // Convert moment objects to Date objects if needed
            const startDate =
              selectedStartDate instanceof Date
                ? selectedStartDate
                : selectedStartDate.toDate();
            const endDate =
              selectedEndDate instanceof Date
                ? selectedEndDate
                : selectedEndDate.toDate();

            // Check if the created date is within the selected date range
            if (createdDate < startDate || createdDate > endDate) {
              return false;
            }
          }
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Recently Added":
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              );
            case "Ascending":
              return a.CompanyName[0].localeCompare(b.CompanyName[0]);
            case "Descending":
              return b.CompanyName[0].localeCompare(a.CompanyName[0]);
            case "Last Month":
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); // Get the date for one month ago
              const lastMonthCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last month, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= oneMonthAgo &&
                new Date(a.CreatedDate) >= oneMonthAgo
              ) {
                return lastMonthCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last month
              }
            case "Last 7 Days":
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Get the date for 7 days ago
              const last7DaysCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last 7 days, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= sevenDaysAgo &&
                new Date(a.CreatedDate) >= sevenDaysAgo
              ) {
                return last7DaysCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last 7 days
              }

            default: // 'Last 7 Days'
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              ); // Adjust logic for 'Last 7 Days'
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          showBasicAlert("No Data");
        }
      }
    }
  }, [statusFilter, planFilter, sortBy, selectedStartDate, selectedEndDate]);

  if (responseDataSubscription == undefined) {
    return <Loader />;
  } else {
    return (
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Subscription</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.superAdminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Superadmin</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Subscription
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={handleExportPDF}
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={handleExportExcel}
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}
            <div className="row">
              {/* Total Transaction */}
              <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body ">
                    <div className="border-bottom pb-3 mb-3">
                      <div className="row align-items-center">
                        <div className="col-7">
                          <div>
                            <span className="fs-14 fw-normal text-truncate mb-1">
                              Total Transaction
                            </span>
                            <h5>
                              ₹
                              {(() => {
                                const totalEarnings =
                                  parseFloat(
                                    responseDataSubscription.totalEarnings
                                  ) || 0;
                                const totalTax =
                                  parseFloat(
                                    responseDataSubscription.totalTax
                                  ) || 0;
                                const totalWithTax =
                                  totalEarnings +
                                  (totalEarnings * totalTax) / 100;

                                return totalWithTax.toFixed(2); // Format to 2 decimal places
                              })()}
                            </h5>
                          </div>
                        </div>
                        <div className="col-5">
                          <ReactApexChart
                            options={totalTransaction}
                            series={totalTransaction.series}
                            type="area"
                            width={60}
                            height={35}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex">
                      <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                        <span className="text-primary fs-12 d-flex align-items-center me-1">
                          <i className="ti ti-arrow-wave-right-up me-1" />
                          {
                            responseDataSubscription?.weekely_percentage?.[0]
                              ?.percentage_change
                          }
                          %
                        </span>
                        from last week
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Total Transaction */}

              {/* Total Subscribers */}
              <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body ">
                    <div className="border-bottom pb-3 mb-3">
                      <div className="row align-items-center">
                        <div className="col-7">
                          <div>
                            <span className="fs-14 fw-normal text-truncate mb-1">
                              Total Subscribers
                            </span>
                            <h5>{responseDataSubscription.totalSubscribers}</h5>
                          </div>
                        </div>
                        <div className="col-5">
                          <ReactApexChart
                            options={totalSubscription}
                            series={totalSubscription.series}
                            type="area"
                            width={60}
                            height={35}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex">
                      <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                        <span className="text-primary fs-12 d-flex align-items-center me-1">
                          <i className="ti ti-arrow-wave-right-up me-1" />
                          {responseDataSubscription
                            ?.subs_weekley_percentage?.[0]?.percentage_change >
                          0
                            ? responseDataSubscription
                                .subs_weekley_percentage[0].percentage_change
                            : 0}
                          %
                        </span>
                        from last week
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body ">
                    <div className="border-bottom pb-3 mb-3">
                      <div className="row align-items-center">
                        <div className="col-7">
                          <div>
                            <span className="fs-14 fw-normal text-truncate mb-1">
                              Active Subscribers
                            </span>
                            <h5>{responseDataSubscription.activeSubscriber}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body ">
                    <div className="border-bottom pb-3 mb-3">
                      <div className="row align-items-center">
                        <div className="col-7">
                          <div>
                            <span className="fs-14 fw-normal text-truncate mb-1">
                              Expired Subscribers
                            </span>
                            <h5>
                              {responseDataSubscription.expiredSubscriber}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Subscription List</h5>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="me-3">
                    <div className="input-icon-end position-relative">
                      <PredefinedDateRanges onDateChange={handleDateChange} />
                      <span className="input-icon-addon">
                        <i className="ti ti-chevron-down" />
                      </span>
                    </div>
                  </div>
                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Plan {planFilter}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      {plan.map((plan: any) => (
                        <li key={plan.id}>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => setPlanFilter(plan.name)}
                          >
                            {plan.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Status {statusFilter}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setStatusFilter("Active")}
                        >
                          Active
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setStatusFilter("Inactive")}
                        >
                          Inactive
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Sort By: {sortBy}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setSortBy("Recently Added")}
                        >
                          Recently Added
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setSortBy("Ascending")}
                        >
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setSortBy("Descending")}
                        >
                          Descending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setSortBy("Last Month")}
                        >
                          Last Month
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setSortBy("Last 7 Days")}
                        >
                          Last 7 Days
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                <Table
                  key={JSON.stringify(filteredData)}
                  dataSource={filteredData}
                  columns={columns}
                  Selection={false}
                />
              </div>
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
            <p className="mb-0">2025 © {company_short_name}</p>
            <p>
              Designed & Developed By{" "}
              <Link to="#" className="text-primary">
                {company_short_name}
              </Link>
            </p>
          </div>
        </div>
        {/* /Page Wrapper */}
        {/* View Invoice */}
        <div className="modal fade" id="view_invoice">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-body p-5">
                <div className="row justify-content-between align-items-center mb-3">
                  <div className="col-md-6">
                    <div className="mb-4">
                      <ImageWithBasePath
                        src="assets/img/logo.svg"
                        className="img-fluid"
                        alt="logo"
                        width={80}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" text-end mb-3">
                      <Link
                        to="#"
                        className="me-2"
                        onClick={() => downloadPDF()}
                      >
                        <i className="ti ti-download" />
                        Download
                      </Link>
                      <br />
                      <br />
                      <h5 className="text-dark mb-1">Invoice</h5>

                      <p className="mb-1 fw-normal">
                        <i className="ti ti-file-invoice me-1" />
                        {selectedPurchase?.InvoiceID}
                      </p>
                      <p className="mb-1 fw-normal">
                        <i className="ti ti-calendar me-1" />
                        Issue date : {selectedPurchase?.CreatedDate}{" "}
                      </p>
                      <p className="fw-normal">
                        <i className="ti ti-calendar me-1" />
                        Due date : {selectedPurchase?.ExpiringDate}{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row mb-3 d-flex justify-content-between">
                  <div className="col-md-7">
                    <p className="text-dark mb-2 fw-medium fs-16">
                      Invoice From :
                    </p>
                    <div>
                      <p className="mb-1">{company_short_name}</p>
                      <p className="mb-1">{company_address_env}</p>
                      <p className="mb-1">{company_email_env}</p>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <p className="text-dark mb-2 fw-medium fs-16">
                      Invoice To :
                    </p>
                    <div>
                      <p className="mb-1">{selectedPurchase?.CompanyName[0]}</p>
                      <p className="mb-1">{selectedPurchase?.Address}</p>
                      <p className="mb-1">{selectedPurchase?.Email[0]}</p>
                    </div>
                  </div>
                </div>
                <div className="mb-4">
                  <div className="table-responsive mb-3">
                    <table className="table">
                      <thead className="thead-light">
                        <tr>
                          <th>Plan</th>
                          <th>Days</th>
                          <th>Created Date</th>
                          <th>Expiring On</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{selectedPurchase?.Plan[0]}</td>
                          <td>
                            {selectedPurchase?.ExpiringDate &&
                            selectedPurchase?.CreatedDate
                              ? Math.ceil(
                                  (new Date(
                                    selectedPurchase?.ExpiringDate
                                  ).getTime() -
                                    new Date(
                                      selectedPurchase?.CreatedDate
                                    ).getTime()) /
                                    (1000 * 60 * 60 * 24)
                                )
                              : "Invalid Dates"}
                          </td>

                          <td>{selectedPurchase?.CreatedDate}</td>
                          <td>{selectedPurchase?.ExpiringDate}</td>
                          <td>
                            {selectedPurchase?.countryCurrency}
                            {selectedPurchase?.Amount}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row mb-3 d-flex justify-content-between">
                  <div className="col-md-4">
                    <div>
                      <h6 className="mb-4">Payment info:</h6>
                      <p className="mb-0">{selectedPurchase?.PaymentMethod}</p>
                      <div className="d-flex justify-content-between align-items-center mb-2 pe-3">
                        <p className="mb-0">Amount</p>
                        <p className="text-dark fw-medium mb-2">
                          {selectedPurchase?.countryCurrency}
                          {selectedPurchase?.Amount}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex justify-content-between align-items-center pe-3">
                      <p className="text-dark fw-medium mb-0">Sub Total</p>
                      <p className="mb-2">
                        {selectedPurchase?.countryCurrency}
                        {parseFloat(selectedPurchase?.Amount) -
                          parseFloat(selectedPurchase?.Tax)}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center pe-3">
                      <p className="text-dark fw-medium mb-0">Tax </p>
                      <p className="mb-2">
                        {selectedPurchase?.countryCurrency}
                        {parseFloat(selectedPurchase?.Tax)}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center pe-3">
                      <p className="text-dark fw-medium mb-0">Total</p>
                      <p className="text-dark fw-medium mb-2">
                        {" "}
                        {selectedPurchase?.countryCurrency}
                        {parseFloat(selectedPurchase?.Amount)}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card border mb-0">
                  <div className="card-body">
                    <p className="text-dark fw-medium mb-2">
                      Terms &amp; Conditions:
                    </p>
                    <p className="fs-12 fw-normal d-flex align-items-baseline mb-2">
                      <i className="ti ti-point-filled text-primary me-1" />
                      All payments must be made according to the agreed
                      schedule. Late payments may incur additional fees.
                    </p>
                    <p className="fs-12 fw-normal d-flex align-items-baseline">
                      <i className="ti ti-point-filled text-primary me-1" />
                      We are not liable for any indirect, incidental, or
                      consequential damages, including loss of profits, revenue,
                      or data.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /View Invoice */}
      </>
    );
  }
};

export default Subscription;
